import './accordion.scss'
import type { AccordionPlusProps } from '@omnia/ui/src/lib'
import { AccordionPlus } from '@omnia/ui/src/lib'
import type { FC } from 'react'

interface AccordionProps extends Omit<AccordionPlusProps, 'header'> {
    title?: string
    titleAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    icon: string | { opened: string; closed: string }
    className?: string
}

export const Accordion: FC<AccordionProps> = props => {
    const { title, titleAs = 'h5', children = <></>, icon = {} as AccordionProps['icon'] } = props
    const H = titleAs
    const isStringIcon = typeof icon === 'string'
    const iconData = isStringIcon ? { iconName: icon } : { openIconName: icon.opened, closedIconName: icon.closed }

    return (
        <AccordionPlus
            {...iconData}
            header={<H>{title}</H>}
            transitionDuration={0.325}
            open={props.open}
            className={props.className}
        >
            {children}
        </AccordionPlus>
    )
}
